export enum ContextualActionType {
    deleteFolder,
    addFile,
    moveToBox,
    markAsRead,
    markAsUnread,
    displayFolder,
    merge,
    setInStandByState,
    removeFromStandByState,
    CopyTrackingLink,
    unlockFolder,
    duplicate,
    archive,
    SetInWaitingArchivingState,
    RemoveFromWaitingArchivingState,
    followFolder,
    stopFollowFolder,
}
